import { Plus } from 'lucide-react';

import { Pill } from './pill';

export interface CustomMeasurementButtonProps {
    label: string;
    onAddCustom: () => void;
}

/**
 * Custom measurement button, mutualized for styling consistency purpose
 */
export function CustomMeasurementButton({ label, onAddCustom }: CustomMeasurementButtonProps) {
    return (
        <Pill variant="add" className="ml-2 text-xs" onClick={onAddCustom}>
            <Plus className="h-3 w-3" />
            {label}
        </Pill>
    );
}
